/*
 * @Author: Chao Yang
 * @Date: 2020-03-24 01:31:51
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-04-24 12:58:27
 */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IInfo } from 'src/app/domain/model/info';
import { SessionService } from 'src/app/domain/service';

@Injectable()
export class HttpHeaderHandler implements HttpInterceptor {
  public info: IInfo;

  private infoKey = 'ad-ip-info';
  private shadowUserKey = 'ad-ip-module';

  constructor(
    private route: ActivatedRoute
  ) {
    if (this.land()) {
      this.info = JSON.parse(localStorage.getItem(this.infoKey));
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let reqClone = req.clone({
      setHeaders: {
        Application: 'CorPro',
        Pack: 'Investor Portal',
        Module: location.href,
      },
    });
    if (this.land()) {
      reqClone = req.clone({
        setHeaders: {
          Application: 'CorPro',
          Pack: 'Investor Portal',
          Module: location.href,
          ModuleId: this.getModuleId(),
        },
      });
    }
    return next.handle(reqClone);
  }

  land(): boolean {
    return localStorage.getItem(this.infoKey) !== null;
  }

  getModuleId() {
    if (localStorage[this.shadowUserKey]) {
      return localStorage[this.shadowUserKey] as string;
    } else {
      return this.info.user.id + '';
    }
  }
}
